import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="mx-auto max-w-2xl px-8 py-16">
            <h1 className="font-gotham text-2xl font-semibold text-neutral-900">
              Something went wrong rendering your link.
            </h1>
            <p className="mt-2 font-inter text-sm text-neutral-600">
              Please check your settings and reload the page.
            </p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
